export const ab_master_chat =  [
  {
    id: 1,
    docs: [
      {
        title:'Предпринимательский кодекс Республики Казахстан ',
        url: 'https://docs.google.com/document/d/1IZpULHRe14t1gJNng7_sFNl-xMgG18U_/edit'
      },
      {
        title: 'Правила государственной поддержки частного  предпринимательства ',
        url: 'https://drive.google.com/file/d/1hxqbugBWon7l5tt1nSDE31Twyx5ePrDl/view?usp=sharing'
      },
      {
        title:'Концепция развития малого и среднего предпринимательства в Республике Казахстан до 2030 года ',
        url: 'https://drive.google.com/file/d/1rtjgyf3pPy0Xoj3uK_IkXaYiXeqP_MNV/view'
      },
    ],
    urls: []
  },
  {
    id: 2,
    docs: [],
    urls: [
      {
        title:'Astana Hub - технопарк IT стартапов ',
        url: 'https://astanahub.com/'
      },
      {
        title: 'Международный финансовый центр "Астана" | МФЦА',
        url: 'https://aifc.kz/ru/home/'
      },
      {
        title:'Most IT Hub',
        url: 'https://mosthub.space/'
      },
    ]
  },
  {
    id: 3,
    docs: [],
    urls: [
      {
        title:'Национальный Банк Республики Казахстан ',
        url: 'https://www.nationalbank.kz/ru'
      },
      {
        title: 'Банки второго уровня РК ',
        url: 'https://egov.kz/cms/ru/articles/banks'
      },
      {
        title:'Most IT Hub',
        url: 'https://mosthub.space/'
      },
    ]
  },
  {
    id: 4,
    docs: [],
    urls: [
      {
        title:'Краудфандинговая платформа "GoCrowd"',
        url: 'https://gocrowd.io/raise'
      },
      {
        title: 'Краудфандинговая платформа "iKapitalist"',
        url: 'https://ikapitalist.kz/'
      },
      {
        title:'Краудфандинговая платформа "InvestRoom"',
        url: 'https://investroom.kz/'
      },
    ]
  },
  {
    id: 5,
    docs: [
      {
        title: 'Закон Республики Казахстан "О государственной регистрации прав на недвижимость"',
        url: 'https://docs.google.com/document/d/1cHkKLZkGfkQlIowxFlLwSHlZd--t4yfN/edit?usp=drive_link&ouid=109589003736962750514&rtpof=true&sd=true'
      },
      {
        title: 'Закон Республики Казахстан "Об утверждении Правил оказания государственной услуги "Государственная регистрация прав (обременений прав) на недвижимое имущество"',
        url: 'https://drive.google.com/file/d/1nTH6Vpr1vVEU9ed7bJGPaLxqyVx_HIEz/view?usp=drive_link'
      },
      {
        title:'Приказ "Об утверждении формы заявления о регистрации прав на недвижимое имущество и иных объектов, уведомления о внесении в регистрационные документы соответствующих записей"',
        url: 'https://docs.google.com/document/d/1jfx0z7DAbFkclcn2OdJl5HQrUWgq68K3/edit?usp=drive_link&ouid=109589003736962750514&rtpof=true&sd=true'
      },
    ],
    urls: []
  },
  {
    id: 6,
    docs: [
      {
        title:'Закон Республики Казахстан "О жилищных отношениях"\n',
        url: 'https://drive.google.com/file/d/1XNE0vACSWxn1E8VI5GUf_dfuC9M4ZClj/view?usp=drive_link'
      },
      {
        title:'Приказ "Об утверждении Правил пользования электрической энергией"',
        url: 'https://docs.google.com/document/d/16Li391CdDUbEkO5OYzVTSihgoaneitgY/edit?usp=drive_link&ouid=109589003736962750514&rtpof=true&sd=true'
      },
      {
        title:'Правила предоставления коммунальных услуг в городе Алматы',
        url: 'https://drive.google.com/file/d/1qIhkd2zZVTR__nxFExJgHEFkJ6c9pd_P/view?usp=drive_link'
      },
      {
        title:'Приказ "Об утверждении типовых форм технических условий на подключение к инженерным сетям"',
        url: 'https://drive.google.com/file/d/1zpKiE23q2KmWvVYHg2Ex9dy8_qlJ_HP4/view?usp=drive_link'
      },
    ],
    urls: []
  },
  {
    id: 7,
    docs: [
      {
        title:'Закон Республики Казахстан "О жилищных отношениях"',
        url: 'https://drive.google.com/file/d/1XNE0vACSWxn1E8VI5GUf_dfuC9M4ZClj/view?usp=drive_link'
      },
      {
        title:'Приказ "Об утверждении Правил осуществления деятельности субъектами естественных монополий"',
        url: 'https://docs.google.com/document/d/18ub6yM7Um94qfYC3YxRcFhnZNs6I4pTL/edit?usp=drive_link&ouid=109589003736962750514&rtpof=true&sd=true'
      },
      {
        title:'Приказ "Об утверждении типовых договоров предоставления регулируемых услуг"',
        url: 'https://drive.google.com/file/d/1Fr4h9PVj17_eJMUh0H7K6YLTh42qFRbc/view?usp=drive_link'
      },
      {
        title:'Приказ "Об утверждении типовых форм технических условий на подключение к инженерным сетям"',
        url: 'https://drive.google.com/file/d/1zpKiE23q2KmWvVYHg2Ex9dy8_qlJ_HP4/view?usp=drive_link'
      },
    ],
    urls: []
  },
  {
    id: 8,
    docs: [
      {
        title:'Закон Республики Казахстан "О газе и газоснабжении"',
        url: 'https://drive.google.com/file/d/1_wSYOW_9o7QFdp1oAmtXfzPj3VFna6oq/view?usp=drive_link'
      },
      {
        title:'Закон Республики Казахстан "О жилищных отношениях"',
        url: 'https://drive.google.com/file/d/1XNE0vACSWxn1E8VI5GUf_dfuC9M4ZClj/view?usp=drive_link'
      },
      {
        title:'Приказ "Об утверждении типовых форм технических условий на подключение к инженерным сетям"',
        url: 'https://drive.google.com/file/d/1zpKiE23q2KmWvVYHg2Ex9dy8_qlJ_HP4/view?usp=drive_link'
      },
      {
        title:'Приказ "Об утверждении Правил осуществления деятельности субъектами естественных монополий"',
        url: 'https://docs.google.com/document/d/18ub6yM7Um94qfYC3YxRcFhnZNs6I4pTL/edit?usp=drive_link&ouid=109589003736962750514&rtpof=true&sd=true'
      },
    ],
    urls: []
  },
  {
    id: 9,
    docs: [
      {
        title:'Водный кодекс Республики Казахстан',
        url: 'https://docs.google.com/document/d/1avZLVFzbbrDqgQpPfv8fDfVBvwbKIE4i/edit?usp=drive_link&ouid=109589003736962750514&rtpof=true&sd=true'
      },
      {
        title:'Закон Республики Казахстан "О жилищных отношениях"',
        url: 'https://drive.google.com/file/d/1XNE0vACSWxn1E8VI5GUf_dfuC9M4ZClj/view?usp=drive_link'
      },
      {
        title:'Приказ "Об утверждении типовых форм технических условий на подключение к инженерным сетям"',
        url: 'https://drive.google.com/file/d/1zpKiE23q2KmWvVYHg2Ex9dy8_qlJ_HP4/view?usp=drive_link'
      },
      {
        title:'Правила пользования системами водоснабжения и водоотведения населенных пунктов',
        url: 'https://drive.google.com/file/d/1UoG4IClfG_uQrgo1vvE7sYvN3RTYsdhv/view?usp=drive_link'
      },
    ],
    urls: []
  },
  {
    id: 10,
    docs: [
      {
        title:'Земельный кодекс Республики Казахстан',
        url: 'https://drive.google.com/file/d/1Bx7mUomstIZ4O2lJDoAOO3CHe9CEuBTQ/view?usp=drive_link'
      },
      {
        title:'Приказ "Об утверждении Правил по оказанию государственных услуг в сфере земельных отношений"',
        url: 'https://drive.google.com/file/d/1CnAM1-xJaJxM9w07Ms0cm_t62iKCNa7H/view?usp=drive_link'
      },
      {
        title:'Закон Республики Казахстан "О государственной регистрации прав на недвижимое имущество"',
        url: 'https://drive.google.com/file/d/1o-2b1XRpwABxobySVziQRFjQ1VRuo2FN/view?usp=drive_link'
      },
    ],
    urls: []
  },
  {
    id: 11,
    docs: [
      {
        title:'Предпринимательский кодекс Республики Казахстан',
        url: 'https://docs.google.com/document/d/1HU3QHeAIm6m17JyjeESwhAeJ7WGfKP_z/edit?usp=drive_link&ouid=108362782146948247079&rtpof=true&sd=true'
      },
      {
        title:'Налоговый кодекс Республики Казахстан',
        url: 'https://docs.google.com/document/d/175iH4wEbLQaCyvo-_9rInUo0E6Cz3m3V/edit?usp=drive_link&ouid=108362782146948247079&rtpof=true&sd=true'
      },
      {
        title:'Закон Республики Казахстан "О противодействии коррупции"',
        url: 'https://docs.google.com/document/d/1YdTHq4aBdEI-E9ZRLa3y2yHC9cQnoKP7/edit?usp=drive_web&ouid=110073192473387425438&rtpof=true'
      },
      {
        title:'Указ Президента РК "О некоторых вопросах Агентства по защите и развитию конкуренции Республики Казахстан"',
        url: 'https://docs.google.com/document/d/11g6uzksNN_l1GCgsq1CbxEycODHCsJO4/edit?usp=drive_link&ouid=108362782146948247079&rtpof=true&sd=true'
      },
    ],
    urls: []
  },
  {
    id: 12,
    docs: [
      {
        title:'Справочник «100 идей для малого бизнеса» от НПП РК',
        url: 'https://drive.google.com/file/d/1JltkkgYvg-msrb1evtXvj2TcAIXo8LkL/view?usp=drive_link'
      },
      {
        title:'Руководство по составлению бизнес плана ЕАС (Таможенный союз)',
        url: 'https://drive.google.com/file/d/1VgP-c0KlIvjTYsbN3D1YA90-sZbyB8LQ/view?usp=drive_link'
      },

    ],
    urls: [
      {
        title:'Национальная палата предпринимателей Республики Казахстан',
        url: 'https://atameken.kz/ru/'
      },
    ]
  },
  {
    id: 13,
    docs: [
      {
        title:'Правила регистрации товарных знаков',
        url: 'https://docs.google.com/document/d/1thSwFmbfWq66C-_2ocu2VcFmcBhjDGh8/edit?usp=drive_link&ouid=108362782146948247079&rtpof=true&sd=true'
      },
      {
        title:'Закон "О товарных знаках, знаках обслуживания, географических указаниях и наименованиях мест происхождения товаров"',
        url: 'https://docs.google.com/document/d/1bN7mEcZCdsrySomXg5SAMP19ZdTeyGAJ/edit?usp=drive_link&ouid=108362782146948247079&rtpof=true&sd=true'
      },
      {
        title:'Правила проведения экспертизы заявок',
        url: 'https://docs.google.com/document/d/1sM7PgvTZ-HcdQLorA93CmQC70tppopKW/edit?usp=drive_link&ouid=108362782146948247079&rtpof=true&sd=true'
      },

    ],
    urls: [
      {
        title:'Национальный институт интеллектуальной собственности',
        url: 'https://qazpatent.kz/ru'
      },
    ]
  },
  {
    id: 14,
    docs: [
      {
        title:'Закон Республики Казахстан "О разрешениях и уведомлениях"',
        url: 'https://docs.google.com/document/d/1x3KdgkijXOaceyhyCkFajok6UUYLurTm/edit?usp=drive_link&ouid=108362782146948247079&rtpof=true&sd=true'
      },
      {
        title:'Закон "Об аккредитации в области оценки соответствия"',
        url: 'https://docs.google.com/document/d/19tWc6njo-RujNhfCngAI6JhoIvhe1pmd/edit?usp=drive_link&ouid=108362782146948247079&rtpof=true&sd=true'
      },
    ],
    urls: [
      {
        title:'Национальный центр аккредитации',
        url: 'https://www.nca.kz/'
      },
    ]
  },
  {
    id: 15,
    docs: [
      {
        title: 'Закон Республики Казахстан "Об авторском праве и смежных правах"',
        url: 'https://docs.google.com/document/d/1mxiajroPAFLDeTRP72ngIy052QwwEkCr/edit?usp=drive_link&ouid=108362782146948247079&rtpof=true&sd=true',
      },
      {
        title: 'Закон "О товарных знаках, знаках обслуживания, географических указаниях и наименованиях мест происхождения товаров"',
        url: 'https://docs.google.com/document/d/1bN7mEcZCdsrySomXg5SAMP19ZdTeyGAJ/edit?usp=drive_link&ouid=108362782146948247079&rtpof=true&sd=true',
      },
      {
        title: 'Патентный закон Республики Казахстан',
        url: 'https://docs.google.com/document/d/15JAnUywcFAO2m1vGAbWI0XD6VuTtcPhb/edit?usp=drive_link&ouid=108362782146948247079&rtpof=true&sd=true',
      },
    ],
    urls: [
      {
        title: 'Национальный институт интеллектуальной собственности',
        url: 'https://qazpatent.kz/ru',
      },
    ]
  }

];
